import appConfig from '@shared/config';

export const GroupSearchServiceMock = adapter =>
  adapter.onPost(`${appConfig.ZION_API}/${appConfig.GROUP_ENDPOINT}`).reply(200, {
    status: 200,
    data: {
      currentLocation: {
        lat: -23.6133983,
        lng: -46.7390024,
      },
      homeGroups: [
        {
          id: '21469',
          name: 'MORUMBI 4',
          categoryName: 'LINKS - FAMÍLIAS',
          categorySlug: 'links-familias',
          typeOfDatingIsOnline: false,
          location: {
            lat: -23.61346,
            lng: -46.73919,
            city: 'São Paulo',
            country: 'BRASIL',
            district: 'VILA SUZANA',
            state: 'Sao Paulo',
          },
          managers: [
            {
              name: 'CARLA ARAUJO FERREIRA FONTES',
              role: 'leader',
            },
            {
              name: 'HIME GOMES DA SILVA CANDIDO',
              role: 'leader',
            },
            {
              name: 'RAFAEL CANDIDO SALES',
              role: 'leader',
            },
            {
              name: 'VAGNER FONTES',
              role: 'leader',
            },
          ],
          operationDays: [
            {
              dayId: 6,
              startAt: '17:30',
              endAt: '19:00',
            },
          ],
        },
        {
          id: '21470',
          name: 'MAUÁ (ABC) - VOX',
          categoryName: 'LINKS - VOX',
          categorySlug: 'links-vox',
          typeOfDatingIsOnline: false,
          location: {
            lat: -23.67954,
            lng: -46.44244,
            city: 'Mauá',
            country: 'BRASIL',
            district: 'Vila Falchi',
            state: 'Sao Paulo',
          },
          managers: [
            {
              name: 'BIANCA APARECIDA DE FREITAS',
              role: 'leader',
            },
          ],
          operationDays: [
            {
              dayId: 4,
              startAt: '20:00',
              endAt: '22:00',
            },
          ],
        },
        {
          id: '21473',
          name: 'CAMPO BELO - VOX',
          categoryName: 'LINKS - VOX',
          categorySlug: 'links-vox',
          typeOfDatingIsOnline: false,
          location: {
            lat: -23.61632,
            lng: -46.67205,
            city: 'São Paulo',
            country: 'BRASIL',
            district: 'CAMPO BELO',
            state: 'Sao Paulo',
          },
          managers: [
            {
              name: 'LETICIA TREVIZAN',
              role: 'leader',
            },
            {
              name: 'RODRIGO MARAFON',
              role: 'leader',
            },
          ],
          operationDays: [
            {
              dayId: 2,
              startAt: '20:30',
              endAt: '22:00',
            },
          ],
        },
        {
          id: '29318',
          name: 'BROOKLIN 1',
          categoryName: 'LINKS - FAMÍLIAS',
          categorySlug: 'links-familias',
          typeOfDatingIsOnline: false,
          location: {
            lat: -23.60974,
            lng: -46.68381,
            city: 'São Paulo',
            country: 'BRASIL',
            district: 'BROOKLIN PAULISTA',
            state: 'Sao Paulo',
          },
          managers: [
            {
              name: 'JUNE PARREIRA',
              role: 'leader',
            },
          ],
          operationDays: [
            {
              dayId: 4,
              startAt: '20:30',
              endAt: '22:00',
            },
          ],
        },
        {
          id: '29320',
          name: 'MORUMBI 1',
          categoryName: 'LINKS - FAMÍLIAS',
          categorySlug: 'links-familias',
          typeOfDatingIsOnline: false,
          location: {
            lat: -23.61589,
            lng: -46.74092,
            city: 'São Paulo',
            country: 'BRASIL',
            district: 'JARDIM LONDRINA',
            state: 'Sao Paulo',
          },
          managers: [
            {
              name: 'MARISETE T. ALONSO AKAO',
              role: 'leader',
            },
            {
              name: 'RENATO ALEXANDRE HIROSHI AKAO',
              role: 'leader',
            },
          ],
          operationDays: [
            {
              dayId: 4,
              startAt: '20:30',
              endAt: '22:00',
            },
          ],
        },
      ],
    },
  });

export const GroupInfoServiceMock = adapter =>
  adapter.onGet(`${appConfig.ZION_API}/${appConfig.GROUP_INFO_ENDPOINT}`).reply(200, {
    status: 200,
    data: {
      id: 21469,
      name: 'MORUMBI 4',
      categoryName: 'LINKS - FAMÍLIAS',
      categorySlug: 'links-familias',
      isRecruiting: true,
      managers: [
        {
          name: 'CARLA ARAUJO FERREIRA FONTES',
          role: 'leader',
          photoUrl:
            'https://sis.sistemaprover.com.br/public/download/1384/2021/02/05_730872_601def43cec63.jpeg',
        },
        {
          name: 'HIME GOMES DA SILVA CANDIDO',
          role: 'leader',
          photoUrl:
            'https://sis.sistemaprover.com.br/public/download/1384/2020/07/29_395250_5f21dc39137e5.jpeg',
        },
        {
          name: 'RAFAEL CANDIDO SALES',
          role: 'leader',
          photoUrl:
            'https://sis.sistemaprover.com.br/public/download/1384/2022/07/04_636592_62c2cd9d1b9c0.jpeg',
        },
        {
          name: 'VAGNER FONTES',
          role: 'leader',
          photoUrl:
            'https://sis.sistemaprover.com.br/public/download/1384/2021/12/05_636601_61ad2298bd19f.jpeg',
        },
      ],
      totalMembers: 28,
      operationDays: [
        {
          dayId: 6,
          startAt: '17:30',
          endAt: '19:00',
        },
      ],
      location: {
        lat: -23.61346,
        lng: -46.73919,
      },
    },
    response: {
      processStatus: 0,
    },
  });
